module.exports = __webpack_public_path__ + "static/media/torso-top-back.d51a23af.png";